import React from 'react';

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Section 标题组件 - 统一样式
 */
export default function SectionTitle({
  children,
  className = '',
}: SectionTitleProps) {
  return (
    <h2
      className={`text-[48px] font-semibold leading-[100%] tracking-[0%] text-[#1A1A1A] mobile:text-[1.75rem] ${className}`}
    >
      {children}
    </h2>
  );
}
